import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { SharedAlertComponent } from './alert.component';

@NgModule({
  imports: [CommonModule, IconModule],
  exports: [SharedAlertComponent],
  declarations: [SharedAlertComponent],
})
export class RdAlertModule {}
